import React, { FC, useLayoutEffect, useRef, useState } from 'react'
import { Icon, Accordion } from 'semantic-ui-react';

import Utility from "../../../../src/Utility";
import AmountProvider from "../../../components/Provider/AmountProvider";

export enum AccordionType {
  Supplement = 'supplement',
  Hebergement = 'hebergement'
}

type Props = {
  title: string
  amount?: number
  currency?: string
  children?: any
  type?: AccordionType
  trigger?: boolean
  afterTrigger?: Function
}

const BookingDetailsAccordion: FC<Props> = ({
  title,
  amount,
  currency,
  children,
  type,
  trigger,
  afterTrigger,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(-1);
  const accordionRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (type === AccordionType.Supplement && trigger) {
      activeIndex === -1 && setActiveIndex(0);
      scrollToEl();
      afterTrigger();
    }
  }, [trigger]);

  const scrollToEl = () => {
    setTimeout(() => {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
      const parent = accordionRef.current.parentNode as HTMLDivElement;
      parent.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }, 500);
  };

  const handleClick = (_, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };

  return (
    <div ref={accordionRef}>
      <Accordion fluid>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          onClick={handleClick}
        >
          <div className="d-flex justify-content-between">
            <Icon name="dropdown" />
            <div style={{ flex: "1" }}>
              <h5>{Utility.upperCase(title)}</h5>
            </div>
            {amount && (
              <div>
                <h5>
                  <AmountProvider amount={amount} currency={currency} />
                </h5>
              </div>
            )}
          </div>
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          <div
            ref={contentRef}
            className="p-2"
            style={{ maxHeight: 250, overflow: "auto", marginBottom: 15 }}
          >
            {children}
          </div>
        </Accordion.Content>
      </Accordion>
    </div>
  );
};

export default BookingDetailsAccordion;